import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { ReleaseNote } from '@pulpo/pulpo-models';

@Injectable({
  providedIn: 'root',
})
export class ReleaseNotesService {
  private releaseNotes$: Observable<ReleaseNote[]> | null = null;

  private http = inject(HttpClient);

  /**
   * Retrieve the release notes from a local JSON file.
   */
  getReleaseNotes(): Observable<ReleaseNote[]> {
    if (!this.releaseNotes$) {
      this.releaseNotes$ = this.http
        .get<ReleaseNote[]>('assets/notes/release-notes.json')
        .pipe(
          shareReplay(1),
          catchError((error) => {
            console.error('Error while getting release note:', error);
            return of([]);
          })
        );
    }
    return this.releaseNotes$ || of([]);
  }

  /**
   * Retrieve the latest release note.
   */
  getLatestReleaseNote(): Observable<ReleaseNote | null> {
    return this.getReleaseNotes().pipe(
      map((notes) => (notes.length > 0 ? notes[0] : null))
    );
  }
}
